import React from "react";
import { Spinner } from "react-bootstrap";
import { loaderMsg } from "../constants";

export function formatDate(dateString) {
  const date = new Date(dateString);

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const monthIndex = date.getMonth();
  const year = date.getFullYear();

  return monthNames[monthIndex] + " " + year;
}

export function formatDateTime(dateTimeString) {
  const date = new Date(dateTimeString);

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const monthIndex = date.getMonth();
  const year = date.getFullYear();

  return (
    date.getDate() +
    " " +
    monthNames[monthIndex] +
    " " +
    year +
    " - " +
    date.getHours() +
    ":" +
    date.getMinutes()
  );
}

export const LoadingOverlay = () => (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999, // Ensure it's above other elements
    }}
  >
    <Spinner
      style={{ width: "3rem", height: "3rem", color: "#fabb3d", fontSize: 20 }}
    >
      {loaderMsg}
    </Spinner>
  </div>
);





// WEBPACK FOOTER //
// ./src/util/Helpers.js